<div class="dx-modal-dialog dx-modal-dialog--alert">
  <div class="dx-modal-dialog__head">
    {{title}}
    <button class="dx-modal-dialog__close"
            type="button"
            title="Закрыть"
            (click)="onCloseClick()">
    </button>
  </div>

  <div class="dx-modal-dialog__body">
    <div class="dx-modal-dialog__icon">
      <!--<img [src]="options.bodyIcon" alt="">-->
    </div>

    <div class="dx-modal-dialog__content">
      <div class="dx-warn-message" [innerHTML]="message | safeHtml"></div>
    </div>

  </div>

  <div class="dx-modal-dialog__foot  dx-modal-dialog__foot--right">
    <div class="dx-modal-dialog__group-btn">
      <ng-container *ngFor="let button of buttons">
        <button class="dx-modal-dialog__btn  dx-modal-dialog__btn--sm"
                (click)="onFooterButtonClick(button)">
          {{button.title}}
        </button>
      </ng-container>
    </div>
  </div>

</div>
